import {
  Component,
  Output,
  EventEmitter,
  ViewChild,
  Input,
} from '@angular/core';
import { ModalController, App, NavController } from 'ionic-angular';
import { UserProvider } from '../../../providers/user/user';
import { ToolsProvider } from '../../../providers/tools/tools';
import * as debug from 'debug';
import * as _ from 'lodash';
import { AppVersion } from '@ionic-native/app-version';
import { EnvVariables } from '../../../environments/environment';
import { ConfigProvider } from '../../../providers/config/config';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'lc-chat-header-users',
  templateUrl: 'chat-header-users.html',
})
export class LCRoomHeaderUsersComponent {
  log = debug('app:LCRoomHeaderUsersComponent');

  @Input() users: [] = [];
  @Input() usersCount: number = null;
  @Output() openDetails = new EventEmitter();

  constructor(
    public modalCtrl: ModalController,
    public user: UserProvider,
    public appCtrl: App,
    public tools: ToolsProvider,
    public appVersion: AppVersion,
    public navCtrl: NavController,
    private env: EnvVariables,
    public configs: ConfigProvider
  ) {}

  ngOnInit(): void {}

  openChatDetailsPage() {}

  navToUsersProfile(user) {
    this.tools.logAnalyticsEvent(
      'trackCustom',
      `lc-view-chatHeader-navToUsersProfile`
    );
    this.navCtrl.push('UserProfilePage', {
      user: user,
      user_id: user._id,
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/_live-chat/chat-header-users/chat-header-users.ts